import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IUserMonitoringState } from "../components/Monitoring/interfaces";

export const initialState: IUserMonitoringState = {
  dashboardCache: {},
  kpiCache: {},
  peakUsageCache: {},
  apiTimingCache: {},
  lastRefreshedAt: null,
};

const userMonitoringSlice = createSlice({
  name: "userMonitoring",
  initialState,
  reducers: {
    setDashboardCache: (
      state,
      action: PayloadAction<{ key: string; data: any }>
    ) => {
      state.dashboardCache[action.payload.key] = {
        data: action.payload.data,
        cachedAt: Date.now(),
      };
    },

    setKpiCache: (
      state,
      action: PayloadAction<{ key: string; data: any }>
    ) => {
      state.kpiCache[action.payload.key] = {
        data: action.payload.data,
        cachedAt: Date.now(),
      };
    },

    setPeakUsageCache: (
      state,
      action: PayloadAction<{ key: string; data: any }>
    ) => {
      state.peakUsageCache[action.payload.key] = {
        data: action.payload.data,
        cachedAt: Date.now(),
      };
    },

    setApiTimingCache: (
      state,
      action: PayloadAction<{ key: string; data: any }>
    ) => {
      state.apiTimingCache[action.payload.key] = {
        data: action.payload.data,
        cachedAt: Date.now(),
      };
    },

    setLastRefreshedAt: (state, action: PayloadAction<string>) => {
      state.lastRefreshedAt = action.payload;
    },

    invalidateDashboardCache: (
      state,
      action: PayloadAction<string | undefined>
    ) => {
      if (action.payload) {
        delete state.dashboardCache[action.payload];
      } else {
        state.dashboardCache = {};
      }
    },

    invalidateKpiCache: (
      state,
      action: PayloadAction<string | undefined>
    ) => {
      if (action.payload) {
        delete state.kpiCache[action.payload];
      } else {
        state.kpiCache = {};
      }
    },

    invalidatePeakUsageCache: (
      state,
      action: PayloadAction<string | undefined>
    ) => {
      if (action.payload) {
        delete state.peakUsageCache[action.payload];
      } else {
        state.peakUsageCache = {};
      }
    },

    invalidateApiTimingCache: (
      state,
      action: PayloadAction<string | undefined>
    ) => {
      if (action.payload) {
        delete state.apiTimingCache[action.payload];
      } else {
        state.apiTimingCache = {};
      }
    },


    invalidateAllCaches: (state) => {
      state.dashboardCache = {};
      state.kpiCache = {};
      state.peakUsageCache = {};
      state.apiTimingCache = {};
    },

  },
});

export const {
  setDashboardCache,
  setKpiCache,
  setPeakUsageCache,
  setApiTimingCache,
  setLastRefreshedAt,
  invalidateDashboardCache,
  invalidateKpiCache,
  invalidatePeakUsageCache,
  invalidateApiTimingCache,
  invalidateAllCaches,
} = userMonitoringSlice.actions;

export default userMonitoringSlice.reducer;